/**
 * Shared Location Form Modal — zod schemas.
 *
 * board2-#79 「地址格式改成一個textfield，丟到googlet拆分」
 * (page 2cb89adb-b34d-80ee-a729-d094a38c45cc): the address entry group is
 * country + postcode + ONE full-address textfield, so the required set here
 * is exactly country/postcode/address (+ locationName and the default
 * toggles). stateId/cityId are UNVALIDATED passthrough — they are
 * backend-parse OUTPUTS (Google Maps split, simulated by the mocks).
 *
 * Pure module (no react/antd deps) so the vitest contract suite can import
 * it in the node environment — mirrors the mockParseAddress pattern.
 */

import { z } from 'zod';

/** Zod schema for vendor location form */
export const vendorLocationFormSchema = z.object({
  locationName: z.string().min(1, 'vendor.validation.locationNameRequired'),
  isDefaultReceiving: z.boolean(),
  country: z.string().min(1, 'vendor.validation.countryRequired'),
  countryId: z.number().nullable(),
  stateId: z.number().nullable(),
  state: z.string().optional(),
  cityId: z.number().nullable(),
  city: z.string().optional(),
  postcode: z.string().min(1, 'vendor.validation.postcodeRequired'),
  address: z.string().min(1, 'vendor.validation.addressRequired'),
  addressLang: z.string().nullable().optional(),
  notes: z.string().optional(),
});

/** Zod schema for customer location form */
export const customerLocationFormSchema = z.object({
  locationName: z.string().min(1, 'customer.validation.locationNameRequired'),
  isDefaultShipping: z.boolean(),
  isDefaultBilling: z.boolean(),
  country: z.string().min(1, 'customer.validation.countryRequired'),
  countryId: z.number().nullable(),
  stateId: z.number().nullable(),
  state: z.string().optional(),
  cityId: z.number().nullable(),
  city: z.string().optional(),
  postcode: z.string().min(1, 'customer.validation.postcodeRequired'),
  address: z.string().min(1, 'customer.validation.addressRequired'),
  addressLang: z.string().nullable().optional(),
  notes: z.string().optional(),
});
